import { computed } from 'vue';
import useContent from '../stores/useContent';

const tagDescriptions = computed(() => {
  const content = useContent();
  return content.compiled['tag-descriptions'];
});

export const hasTagDescriptions = computed(() => {
  return tagDescriptions.value !== undefined;
});

export const tagDescription = (tag: string) => {
  const hasDesc = hasTagDescriptions.value
    ? tagDescriptions.value[tag] !== undefined
    : false;
  return hasDesc ? `${tagDescriptions.value[tag]}` : '';
};

const processTagString = (tag: string) => {
  // split tags at spaces or return a single element array
  return tag.indexOf(' ') !== -1 ? tag.split(' ') : [tag];
};

const processTagObject = (obj: object) => {
  if (obj['of']) {
    if (typeof obj['of'] === 'string') {
      return processTagString(obj['of']);
    } else {
      return Object.keys(obj['of']).map(key => obj['of'][key]);
    }
  } else {
    return [];
  }
};

const getTags = obj => {
  if (!obj.tag) return [];

  if (typeof obj.tag === 'string') {
    return processTagString(obj.tag);
  } else if (typeof obj.tag === 'object') {
    // if the tag is an array (has length) each could be a single tag string, space-separated tags or tag objects (with any/of props)
    if (obj.tag.length) {
      // iterate over each tag object and collate all the tags
      let tags: string[] = [];
      obj.tag.forEach(tag => {
        if (typeof tag === 'string') {
          tags = [...tags, ...processTagString(tag)];
        } else if (typeof tag === 'object') {
          tags = [...tags, ...processTagObject(tag)];
        }
      });
      // remove any duplicates
      return tags.filter((tag, index, self) => self.indexOf(tag) === index);
    } else {
      return processTagObject(obj.tag);
    }
  }
};

export default getTags;
